import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function ImageRender({ node }) {
  const content = node.content || {};
  const src = content.url || 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=800&auto=format&fit=crop';
  const alt = content.alt || 'Bild';
  const align = content.align || 'center';
  const objectFit = content.objectFit || 'cover';
  const radius = content.radius || '8px';

  return (
    <div style={{ display: 'flex', justifyContent: align, width: '100%', height: '100%' }}>
      <img 
        src={src} 
        alt={alt} 
        style={{ 
          maxWidth: '100%', 
          height: '100%',
          objectFit: objectFit,
          borderRadius: radius,
          display: 'block'
        }} 
      />
    </div>
  );
}

registry.register('Image', {
  label: 'Bild',
  icon: '🖼️', 
  category: 'media',
  component: ImageRender,
  
  defaultProps: {
    content: {
      url: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=800&auto=format&fit=crop',
      alt: '',
      align: 'center',
      objectFit: 'cover',
      radius: '8px'
    },
    style: {
      desktop: {}
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Bild Quelle',
          fields: [
            { name: 'content.url', label: 'Bild-URL', type: 'image' },
            { name: 'content.alt', label: 'Alt-Text (SEO)', type: 'text' }
          ]
        },
        {
          title: 'Darstellung',
          fields: [
            { name: 'content.objectFit', label: 'Einpassung', type: 'select', options: ['cover', 'contain', 'fill'] },
            { name: 'content.radius', label: 'Eckenradius', type: 'text' },
            { name: 'content.align', label: 'Ausrichtung', type: 'select', options: ['flex-start', 'center', 'flex-end'] }
          ]
        }
      ]
    }
  ]
});
